import React, { Component } from 'react';
import { restartIcon } from '../../../assets/images';
import Button from 'react-bootstrap/Button';
import { validate, formatter } from '../../../utility';
import moment from 'moment';
import { RentalAddress } from './RentalAddress';
import { DecisionQuestions } from './DecisionQuestions';
import { PreviousRentIncreaseQuestions } from './PreviousRentIncreaseQuestions';
import { FutureRentIncreaseQuestions } from './FutureRentIncreaseQuestions';
import GeneralUtils from '../../../utility/GeneralUtils';

const DROPDOWN_YES_VALUE = '1';
const DROPDOWN_NO_VALUE = '0';
class StepOne extends Component {
  state = {
    //input state
    streetAddress: '',
    city: '',
    postalCode: '',

    userAccessDate: moment().toDate(),
    decisionDate:'',
    decisionEligibleAmount: '',
    decisionRentAmount: '',

    isPreviousYearRentIncrease: '',
    previousYearRentIncreaseDate: '',

    isExistingRentIncrease: '',
    existingNoticeServiceDate: '',
    existingRentEffectiveDate: '',
    existingRentAmount: '',

    //input errors
    errors: {
      streetAddress: null,
      city: null,
      postalCode: null,
      userAccessDate: null,
      decisionDate: null,
      decisionEligibleAmount: null,
      decisionRentAmount: null,
      isPreviousYearRentIncrease: null,
      previousYearRentIncreaseDate: null,
      isExistingRentIncrease: null,
      existingNoticeServiceDate: null,
      existingRentEffectiveDate: null,
      existingRentAmount: null
    },
  }

  componentDidMount() {
    const { stepOneData } = this.props;
    if (Object.keys(stepOneData).length === 0) return;

    this.setState({
      streetAddress: stepOneData.streetAddress || '',
      city: stepOneData.city || '', 
      postalCode: stepOneData.postalCode || '', 
      userAccessDate: stepOneData.userAccessDate || moment().toDate(), 
      decisionDate: stepOneData.decisionDate || '', 
      decisionEligibleAmount: stepOneData.decisionEligibleAmount || '', 
      decisionRentAmount: stepOneData.decisionRentAmount || '', 
      isPreviousYearRentIncrease: stepOneData.isPreviousYearRentIncrease || '', 
      previousYearRentIncreaseDate: stepOneData.previousYearRentIncreaseDate || '', 
      isExistingRentIncrease: stepOneData.isExistingRentIncrease || '',
      existingNoticeServiceDate: stepOneData.existingNoticeServiceDate || '',
      existingRentEffectiveDate: stepOneData.existingRentEffectiveDate || '',
      existingRentAmount: stepOneData.existingRentAmount || ''
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: '' },
    });
  };

  handleDateChange = (value, event) => {
    const { name } = event;
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: '' },
    });
  }

  handleDecisionDateChange = (value, event) => {
    const decisionDate = value;
    const { previousYearRentIncreaseDate, eightMonthsBeforeDecisionDate, existingNoticeServiceDate } = this.state;
    if (!moment(previousYearRentIncreaseDate).isBetween(moment(eightMonthsBeforeDecisionDate), moment(decisionDate))) {
      this.setState({ previousYearRentIncreaseDate: '' });
    }

    if (moment(existingNoticeServiceDate).isBefore(moment(decisionDate).subtract(6, 'months'))) {
      this.setState({ existingNoticeServiceDate: '', existingRentEffectiveDate: '' });
    }
    
    this.setState({
      decisionDate,
      errors: { ...this.state.errors, decisionDate: '' },
    });
  }

  handleExistingNoticeServiceDateChange = (value, event) => {
    const existingNoticeServiceDate = value;
    const { existingRentEffectiveDate } = this.state;
    if (moment(existingRentEffectiveDate).isBefore(moment(existingNoticeServiceDate))) {
      this.setState({ existingRentEffectiveDate: '' });
    }

    this.setState({
      existingNoticeServiceDate,
      errors: { ...this.state.errors, existingNoticeServiceDate: '' },
    });
  }

  handleIsExistingRentIncrease = (event) => {
    const { name, value } = event.target;
    let additionalStateChanges = {};
    if (value === DROPDOWN_NO_VALUE) {
      additionalStateChanges = {
        existingNoticeServiceDate: '',
        existingRentEffectiveDate: '',
        existingRentAmount: ''
      }
    }

    this.setState({
      isExistingRentIncrease: value,
      errors: { ...this.state.errors, [name]: '' },
      ...additionalStateChanges
    });
  }

  handleIsPreviousYearRentIncrease = (event) => {
    const { value, name } = event.target;
    let additionalStateChanges = {};
    if (value === DROPDOWN_NO_VALUE) {
      additionalStateChanges = {
        previousYearRentIncreaseDate: ''
      }
    }

    this.setState({
      isPreviousYearRentIncrease: value,
      errors: { ...this.state.errors, [name]: '' },
      ...additionalStateChanges
    });
  }

  submitStepOne() {
    const { 
      streetAddress, 
      city, 
      postalCode, 
      userAccessDate, 
      decisionDate, 
      decisionEligibleAmount, 
      decisionRentAmount, 
      isPreviousYearRentIncrease, 
      previousYearRentIncreaseDate, 
      isExistingRentIncrease,
      existingNoticeServiceDate,
      existingRentEffectiveDate,
      existingRentAmount
    } = this.state;

    const { setStepOneStatus } = this.props;

    const eightMonthsBeforeDecisionDate = moment(decisionDate).startOf('month').subtract(8, 'months').toDate();

    const addressValidations = [
      {
        streetAddress,
        validationRules: [{ minLength: 6 },{ isRequired: true, errorMsg: 'Address is required' }],
      },
      {
        city,
        validationRules: [{ minLength: 3 }, { isRequired: true, errorMsg: 'City is required' }],
      },
      {
        postalCode,
        validationRules: [{ postalCode: true }, { isRequired: true, errorMsg: 'Postal Code is required' }],
      },
    ];

    const decisionQuestionsValidations = [
      {
        userAccessDate,
        validationRules: [{ isRequired: true, errorMsg: 'Date is required' }]
      },
      {
        decisionDate,
        validationRules: [{ isRequired: true, errorMsg: 'Date is required' }]
      },
      {
        decisionEligibleAmount,
        validationRules: [{ minValue: 0 }, { isRequired: true, errorMsg: 'Amount is required' }]
      },
      {
        decisionRentAmount,
        validationRules: [{ minValue: 0 }, { isRequired: true, errorMsg: 'Amount is required' }]
      }
    ];

    const previousRentIncreaseQuestionsValidations = [
      {
        isPreviousYearRentIncrease,
        validationRules: [{ isRequired: true, errorMsg: 'Answer is required' }]
      },
      {
        previousYearRentIncreaseDate,
        validationRules: [
          isPreviousYearRentIncrease === DROPDOWN_YES_VALUE && eightMonthsBeforeDecisionDate ? { minDate: eightMonthsBeforeDecisionDate } : {},
          isPreviousYearRentIncrease === DROPDOWN_YES_VALUE && decisionDate ? { maxDate: decisionDate } : {},
          { isRequired: isPreviousYearRentIncrease === DROPDOWN_YES_VALUE, errorMsg: 'Date is required' },
        ]
      }
    ];

    const existingRentIncreaseQuestionsValidation = [
      {
        isExistingRentIncrease,
        validationRules: [{ isRequired: true, errorMsg: 'Answer is required' }]
      },
      {
        existingNoticeServiceDate,
        validationRules: [
          isExistingRentIncrease === DROPDOWN_YES_VALUE && decisionDate ? { minDate: moment(decisionDate).subtract(6, 'months').toDate() } : {},
          { isRequired: isExistingRentIncrease === DROPDOWN_YES_VALUE, errorMsg: 'Date is required' },
        ]
      },
      {
        existingRentEffectiveDate,
        validationRules: [
          isExistingRentIncrease === DROPDOWN_YES_VALUE && existingNoticeServiceDate ? { minDate: existingNoticeServiceDate } : {},
          { isRequired: isExistingRentIncrease === DROPDOWN_YES_VALUE, errorMsg: 'Date is required' },
        ]
      },
      {
        existingRentAmount,
        validationRules: [{ minValue: 0 }, { isRequired: isExistingRentIncrease === DROPDOWN_YES_VALUE, errorMsg: 'Rent amount is required' }]
      }
    ]

    const validationArray = [...addressValidations, ...decisionQuestionsValidations, ...previousRentIncreaseQuestionsValidations, ...existingRentIncreaseQuestionsValidation];

    let err = validate(validationArray);
    console.log('err: ', err);
    if (Object.keys(err).length >= 1) {
      this.setState({ errors: err });
    } else {
      this.setStepOneVars();
      setStepOneStatus(true);
    }
  }

  calculateRentVars = (earliestDecisionServiceDate) => {
    const { existingRentEffectiveDate, decisionDate, existingNoticeServiceDate, existingRentAmount, previousYearRentIncreaseDate, decisionRentAmount } = this.state;
    let dateUsedForMinMaxCalc = '', minRentIncreaseDate = '', rentAmountUsedForCalc = '', oneYearAfterLastRentIncreaseDate ='';

    if (existingRentEffectiveDate && (moment(existingRentEffectiveDate).isAfter(moment(decisionDate)) && moment(existingNoticeServiceDate).isBefore(moment(decisionDate))) ) {
      dateUsedForMinMaxCalc = 'In-Flight Rent Increase';
      minRentIncreaseDate = moment(existingRentEffectiveDate).add(1, 'year').toDate();
      rentAmountUsedForCalc = existingRentAmount;
      oneYearAfterLastRentIncreaseDate = moment(existingRentEffectiveDate).add(1, 'year').toDate();
    } else if (existingRentEffectiveDate && moment(existingRentEffectiveDate).isAfter(moment(decisionDate)) && moment(existingNoticeServiceDate).isAfter(decisionDate)) {
      dateUsedForMinMaxCalc = 'Post-Decision Rent Increase';
      minRentIncreaseDate = existingRentEffectiveDate;
      rentAmountUsedForCalc = existingRentAmount;
    } else if (!existingRentEffectiveDate && !previousYearRentIncreaseDate) {
      dateUsedForMinMaxCalc = 'Decision';
      minRentIncreaseDate= earliestDecisionServiceDate;
      rentAmountUsedForCalc = decisionRentAmount;
    } else if (previousYearRentIncreaseDate && moment(previousYearRentIncreaseDate).add(1, 'year').isSameOrAfter(moment(earliestDecisionServiceDate))) { 
      dateUsedForMinMaxCalc = 'Previous Rent Increase';
      minRentIncreaseDate = moment(previousYearRentIncreaseDate).add(1, 'year');
      rentAmountUsedForCalc = decisionRentAmount;
      oneYearAfterLastRentIncreaseDate = moment(existingRentEffectiveDate ? existingRentEffectiveDate : previousYearRentIncreaseDate).add(1, 'year').toDate();
    }

    return { dateUsedForMinMaxCalc, minRentIncreaseDate, rentAmountUsedForCalc, oneYearAfterLastRentIncreaseDate };
  }

  getCalcRentIncreaseServiceTimeIsAvailable = (earliestServiceDate, maxRentIncreaseDate) => {
    if (!earliestServiceDate || !maxRentIncreaseDate || !maxRentIncreaseDate) return false;
    return moment(earliestServiceDate).isBefore(maxRentIncreaseDate) || moment().isBefore(moment(maxRentIncreaseDate));
  }

  setStepOneVars = () => {
    const { 
      userAccessDate, 
      decisionDate, 
      decisionEligibleAmount, 
      decisionRentAmount, 
      existingNoticeServiceDate, 
      existingRentEffectiveDate, 
      streetAddress, 
      city, 
      postalCode, 
      isPreviousYearRentIncrease ,
      previousYearRentIncreaseDate,
      isExistingRentIncrease,
      existingRentAmount
    } = this.state;
    const { setStepOneVars, setStepTwoStatus, setStepThreeStatus } = this.props;

    const address = `${streetAddress}, ${city}, BC, Canada, ${postalCode}`;
    const eightMonthsBeforeDecisionDate = moment(decisionDate).startOf('month').subtract(8, 'months').toDate();
    const earliestServiceDate = moment(userAccessDate).startOf('month').add(4, 'months').toDate();
    const earliestDecisionServiceDate = moment(decisionDate).startOf('month').add(4, 'months').toDate();
    const calculatedRentVars = this.calculateRentVars(earliestDecisionServiceDate);
    const dateUsedForMinMaxCalc = calculatedRentVars.dateUsedForMinMaxCalc; 
    const minRentIncreaseDate = calculatedRentVars.minRentIncreaseDate ? moment(calculatedRentVars.minRentIncreaseDate).toDate() : '-';
    const rentAmountUsedForCalc = calculatedRentVars.rentAmountUsedForCalc;
    const maxRentIncreaseDate = calculatedRentVars.minRentIncreaseDate ? moment(minRentIncreaseDate).add(1, 'year').subtract(1, 'day').toDate() : '-';
    const oneYearAfterLastRentIncreaseDate = calculatedRentVars.oneYearAfterLastRentIncreaseDate;
    const calcRentIncreaseCausedLoss = moment(existingNoticeServiceDate).isAfter(moment(decisionDate)) && moment(existingRentEffectiveDate).isAfter(moment(earliestDecisionServiceDate));
    const calcRentIncreaseServiceTimeIsAvailable = this.getCalcRentIncreaseServiceTimeIsAvailable(earliestServiceDate, maxRentIncreaseDate);
    const calcMissedRentIncreaseDate = calcRentIncreaseCausedLoss ? existingRentEffectiveDate
      : !calcRentIncreaseServiceTimeIsAvailable ? maxRentIncreaseDate
      : null;
    const not1YearBetweenRentIncreases = moment(existingRentEffectiveDate).subtract(1, 'year').isBefore(moment(previousYearRentIncreaseDate));
    const not3MonthsForService = moment(existingRentEffectiveDate).subtract(3, 'months').isBefore(moment(existingNoticeServiceDate));

    const stepOneVars = {
      address,
      streetAddress, 
      city, 
      postalCode,
      userAccessDate,
      earliestServiceDate,
      earliestDecisionServiceDate,
      decisionEligibleAmount,
      calculatedRentVars,
      dateUsedForMinMaxCalc,
      minRentIncreaseDate,
      rentAmountUsedForCalc,
      maxRentIncreaseDate,
      oneYearAfterLastRentIncreaseDate,
      calcRentIncreaseCausedLoss,
      calcRentIncreaseServiceTimeIsAvailable,
      calcMissedRentIncreaseDate,
      decisionDate,
      decisionRentAmount,
      isPreviousYearRentIncrease,
      previousYearRentIncreaseDate,
      existingNoticeServiceDate,
      existingRentEffectiveDate,
      existingRentAmount,
      isExistingRentIncrease,
      not1YearBetweenRentIncreases,
      not3MonthsForService
    }

    GeneralUtils.log('----- PRINTING ALL STEP 1 VARIABLES -----', 'success');
    GeneralUtils.log(`
      address: ${address}\n
      userAccessDate: ${formatter.toDateDisplay(userAccessDate)}\n
      decisionDate: ${formatter.toDateDisplay(decisionDate)}\n
      decisionEligibleAmount: ${decisionEligibleAmount}\n
      decisionRentAmount: ${decisionRentAmount}\n
      8MonthsBeforeDecisionDate: ${formatter.toDateDisplay(eightMonthsBeforeDecisionDate)}\n
      isPreviousYearRentIncrease: ${!!isPreviousYearRentIncrease}\n
      previousYearRentIncreaseDate: ${formatter.toDateDisplay(previousYearRentIncreaseDate)}\n
      isExistingRentIncrease: ${!!isExistingRentIncrease}\n
      earliestServiceDate: ${formatter.toDateDisplay(earliestServiceDate)}\n
      earliestDecisionServiceDate: ${formatter.toDateDisplay(earliestDecisionServiceDate)}\n
      dateUsedForMinMaxCalc: ${dateUsedForMinMaxCalc}\n
      minRentIncreaseDate: ${formatter.toDateDisplay(minRentIncreaseDate)}\n
      maxRentIncreaseDate: ${formatter.toDateDisplay(maxRentIncreaseDate)}\n
      oneYearAfterLastRentIncreaseDate: ${formatter.toDateDisplay(oneYearAfterLastRentIncreaseDate)}\n
      rentAmountUsedForCalc: ${rentAmountUsedForCalc}\n
      existingNoticeServiceDate: ${formatter.toDateDisplay(existingNoticeServiceDate)}\n
      existingRentEffectiveDate: ${formatter.toDateDisplay(existingRentEffectiveDate)}\n
      existingRentAmount: ${existingRentAmount}\n
      calcRentIncreaseCausedLoss: ${calcRentIncreaseCausedLoss}\n
      calcRentIncreaseServiceTimeIsAvailable: ${calcRentIncreaseServiceTimeIsAvailable}\n
      calcMissedRentIncreaseDate: ${formatter.toDateDisplay(calcMissedRentIncreaseDate)}\n
      not1YearBetweenRentIncreases: ${not1YearBetweenRentIncreases}\n
      not3MonthsForService: ${not3MonthsForService}
      `
      , 'end');
    
    setStepOneVars(stepOneVars);
  }

  modifyClicked = () => {
    this.props.setStepOneStatus(false);
  }

  render() {
    const { 
      streetAddress,
      city,
      postalCode,
      userAccessDate,
      decisionDate,
      decisionEligibleAmount,
      decisionRentAmount,
      isPreviousYearRentIncrease,
      previousYearRentIncreaseDate,
      errors,
      isExistingRentIncrease,
      existingNoticeServiceDate,
      existingRentEffectiveDate,
      existingRentAmount
    } = this.state;
    const { cpiConfig, submitted } = this.props;

    const renderModifyButton = () => submitted ? <span className="w1-step-one__modify" onClick={() => this.modifyClicked()}><img src={restartIcon} alt=""/> Modify</span> : null;
    const address = `${streetAddress}, ${city}, BC, Canada, ${postalCode}`;
    return (
      <div className="w1-step-one">
        <p className="w1-step-one__address__label">Please provide the address of the rental unit for this rent increase <span className="w1-step-one__address__label--print show-print">&nbsp;{address}</span></p>
          <RentalAddress
            disabled={submitted}
            streetAddress={streetAddress}
            city={city}
            postalCode={postalCode}
            errors={errors}
            handleChange={this.handleChange}
          />
          <DecisionQuestions 
            disabled={submitted}
            userAccessDate={userAccessDate}
            decisionDate={decisionDate}
            decisionEligibleAmount={decisionEligibleAmount}
            decisionRentAmount={decisionRentAmount}
            minDecisionDate={cpiConfig.min_decision_date}
            errors={errors}
            handleChange={this.handleChange}
            handleDateChange={this.handleDateChange}
            handleDecisionDateChange={this.handleDecisionDateChange}
          />
          <PreviousRentIncreaseQuestions
            disabled={submitted}
            decisionDate={decisionDate}
            isPreviousYearRentIncrease={isPreviousYearRentIncrease}
            previousYearRentIncreaseDate={previousYearRentIncreaseDate}
            errors={errors}
            handleIsPreviousYearRentIncrease={this.handleIsPreviousYearRentIncrease}
            handleDateChange={this.handleDateChange}
          />
          <FutureRentIncreaseQuestions
            disabled={submitted}
            decisionDate={decisionDate}
            isExistingRentIncrease={isExistingRentIncrease}
            existingNoticeServiceDate={existingNoticeServiceDate}
            existingRentEffectiveDate={existingRentEffectiveDate}
            existingRentAmount={existingRentAmount}
            previousYearRentIncreaseDate={previousYearRentIncreaseDate}
            errors={errors}
            handleChange={this.handleChange}
            handleDateChange={this.handleDateChange}
            handleIsExistingRentIncrease={this.handleIsExistingRentIncrease}
            handleExistingNoticeServiceDateChange={this.handleExistingNoticeServiceDateChange}
          />
        <div className="w1-step-one__buttons hide-print">
          <Button variant="primary" className="step1-continue" onClick={() => this.submitStepOne()} disabled={submitted}>Continue</Button>
          {renderModifyButton()}
        </div>
      </div>
    );
  }
}

export default StepOne;